import React, { useEffect } from 'react'
import { btnSecondary } from '../knowledgePageLayout'
import AgentAccessSummary from './AgentAccessSummary'
import { agentAccessDrawerWidth, agentColors, glassDrawerShellStyle } from './agentChatLayout'

/**
 * Right drawer showing permission manifest (My Access).
 */
export default function AgentAccessDrawer({ open, onClose, permissions, permError, permLoading }) {
  useEffect(() => {
    if (!open) return
    const onKey = (e) => {
      if (e.key === 'Escape') onClose()
    }
    document.addEventListener('keydown', onKey)
    document.body.style.overflow = 'hidden'
    return () => {
      document.removeEventListener('keydown', onKey)
      document.body.style.overflow = ''
    }
  }, [open, onClose])

  if (!open) return null

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: agentColors.overlay,
        zIndex: 1100,
        display: 'flex',
        justifyContent: 'flex-end',
      }}
      onClick={onClose}
      role="presentation"
    >
      <div
        style={{
          width: 'min(100vw, 400px)',
          maxWidth: agentAccessDrawerWidth,
          height: '100%',
          ...glassDrawerShellStyle,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-label="Your access"
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '14px 16px',
            borderBottom: '1px solid rgba(255,255,255,0.45)',
            background: 'rgba(255,255,255,0.35)',
            backdropFilter: 'blur(12px)',
            flexShrink: 0,
          }}
        >
          <div style={{ fontSize: 16, fontWeight: 700, color: agentColors.textPrimary }}>
            Your access
          </div>
          <button
            type="button"
            aria-label="Close"
            onClick={onClose}
            style={{
              ...btnSecondary,
              padding: '6px 12px',
              fontSize: 18,
              lineHeight: 1,
              border: 'none',
              background: 'transparent',
              color: agentColors.textSecondary,
            }}
          >
            ×
          </button>
        </div>

        <div style={{ flex: 1, overflowY: 'auto', padding: '16px 18px' }}>
          {permLoading ? (
            <div style={{ fontSize: 14, color: agentColors.textMuted }}>Loading your access…</div>
          ) : permError ? (
            <div style={{ fontSize: 13, color: agentColors.danger }}>{permError}</div>
          ) : (
            <AgentAccessSummary manifest={permissions} compact />
          )}
        </div>
      </div>
    </div>
  )
}
